export default __webpack_public_path__ + "static/media/classroom.0ab38bc5.png";